import React from 'react';
import { Radio } from 'lucide-react';

const ScannerVisualizer = ({ isPlaying }) => {
  return (
    <div className="flex items-center gap-1 h-6">
      {[...Array(12)].map((_, i) => (
        <div
          key={i}
          className={`w-1 bg-teal-500 rounded-full transition-all duration-150 ${
            isPlaying ? 'animate-pulse' : ''
          }`}
          style={{
            height: isPlaying ? `${Math.random() * 100}%` : '20%',
            animationDelay: `${i * 50}ms`,
            opacity: isPlaying ? 1 : 0.3
          }}
        />
      ))}
    </div>
  );
};

export const ScannerBar = ({ isPlaying, drillPath }) => {
  if (!isPlaying) return null;
  
  return (
    <div className="px-4 pb-2 flex items-center gap-3">
      <div className="flex-1 h-8 rounded bg-slate-900/80 border border-slate-800 overflow-hidden flex items-center px-3">
        <Radio className="w-4 h-4 text-teal-400 mr-2 animate-pulse" />
        <ScannerVisualizer isPlaying={isPlaying} />
        <span className="ml-3 text-xs text-slate-400 font-mono">
          {drillPath.precinct || drillPath.county || drillPath.state || 'National'} Scanner Feed
        </span>
      </div>
    </div>
  );
};

export default ScannerVisualizer;
